import {AfterViewInit, Component, OnDestroy, OnInit} from "@angular/core";
import {map, Subject, switchMap} from "rxjs";
import {ImageService} from "../../../services/image.service";
import {ActivatedRoute, ParamMap} from "@angular/router";
import {NewsService} from "../../../services/news.service";
import {News} from "../../../model/models";
import {InformationService} from "../../../services/information.service";
import {  SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'news-info',
  templateUrl: './news-info.component.html',
  styleUrls: ['./news-info.component.less',
  ]
})
export class NewsInfoComponent implements OnDestroy, OnInit, AfterViewInit{

  private destroySubject: Subject<void> = new Subject();

  news: News = new News();

  constructor(
    private route: ActivatedRoute,
    public imageService: ImageService,
    private newsService: NewsService,
    private informationService: InformationService,

  ) {
  }

  ngOnInit() {


    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
          return this.newsService.getNewsInfo(params?.get('id'));
        }
      ),
      map((res: News) => {
        this.news = res;
      })
    )
      .subscribe();
  }

  getSanitize(toSanitize: string): SafeHtml {
    return this.informationService.getSanitizeString( toSanitize);
  }



  ngAfterViewInit() {

  }


  ngOnDestroy() {
    this.destroySubject.next();

  }



}
